import { render, staticRenderFns } from "./AddToHomescreenPopup.vue?vue&type=template&id=734d8f3e&scoped=true&"
import script from "./AddToHomescreenPopup.vue?vue&type=script&lang=js&"
export * from "./AddToHomescreenPopup.vue?vue&type=script&lang=js&"
import style0 from "./AddToHomescreenPopup.vue?vue&type=style&index=0&id=734d8f3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734d8f3e",
  null
  
)

/* custom blocks */
import block0 from "./AddToHomescreenPopup.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports